// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__3Q2zp","menu":"styles_menu__cSITx","fixedMenu":"styles_fixedMenu__3XZ9F","content":"styles_content__rT-CQ"};